var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 275,
    height: 60,
    viewBox: "0 0 275 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#d73648;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.91,35.4h-.16c3,7,6.8,15.49,8.34,20.86a24.24,24.24,0,0,1,8.77,0c-2.56-5-7.86-16.9-13.46-29.65q-3,1.55-5.94,3.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.08,50.28a19.51,19.51,0,0,0-.47,3.49,20.82,20.82,0,0,1-10.68,2.8c-10,0-15.8-6.55-15.8-15.42,0-8.31,5.17-15.2,16.49-15.2a25,25,0,0,1,10.64,2.28,14,14,0,0,0-1,4.31h-.43c-1.16-2.46-5-4.74-9.34-4.74-6.8,0-11.33,5-11.33,13.31,0,9,5.56,13.39,11.67,13.39a12.64,12.64,0,0,0,9.78-4.44l.52.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.72,50.28a19.52,19.52,0,0,0-.47,3.49,20.82,20.82,0,0,1-10.68,2.8c-10,0-15.8-6.55-15.8-15.42,0-8.31,5.17-15.2,16.49-15.2a25,25,0,0,1,10.64,2.28,14,14,0,0,0-1,4.31h-.43c-1.16-2.46-5-4.74-9.35-4.74-6.8,0-11.33,5-11.33,13.31,0,9,5.56,13.39,11.67,13.39a12.64,12.64,0,0,0,9.78-4.44l.52.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,.45H33.39C25,19.19,16.35,37.69,7.5,56.27a14.08,14.08,0,0,1,3.06-.4,14,14,0,0,1,3.06.4,208.36,208.36,0,0,1,8-21.28h0L32.23,11.17,38.49,25q2.83-1.88,5.8-3.58C40.75,13.3,38,7.25,35,.45Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.91,12.3a104.25,104.25,0,0,0-33.21,12q-3,1.7-5.8,3.58a99.55,99.55,0,0,0-19.16,16.6A165.06,165.06,0,0,1,40.09,30.6Q43,28.92,46,27.37A118.07,118.07,0,0,1,78.83,16c22.93-4.15,45.39-.24,64.85,6.06A102.13,102.13,0,0,0,77.91,12.3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.1d7f23fafc9b59aed1931b17d07b2dd1.svg";
export { ForwardRef as ReactComponent };